import tw from "twin.macro";

export const List = tw.div`
  w-full flex flex-col gap-4
  lg:gap-6 
`;
